import styled from "styled-components"

export const Container = styled.div`
    grid-column: span 2;
    margin-bottom:40px;
    color:#fff;
`
